import type { IconName } from './Icon';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import DynamicIcon from './Icon';

function InfoBanner({
  title,
  message,
  iconName,
}: {
  title: string;
  message: string;
  iconName: IconName;
}) {
  return (
    <Box component="section" sx={{ mb: 2 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5,
          p: '12px 14px',
          borderRadius: '10px',
          border: '1px solid #e9d5ff',
          background: '#faf5ff',
          color: '#5b21b6',
        }}
      >
        <DynamicIcon iconName={iconName} />
        <Box>
          <Typography variant="subtitle1" fontWeight={700} gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" color="#4A5568">
            {message}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
export default InfoBanner;
